import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
// slices
import productReducer from "./slices/product";
import calendarReducer from "./slices/calendar";
import userReducer from "./slices/user";
import roleReducer from "./slices/role";
import accessReducer from "./slices/access";
import chatReducer from "./slices/chat";
import kanbanReducer from "./slices/kanban";
import companyReducer from "./slices/company";
// ----------------------------------------------------------------------

export const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

const productPersistConfig = {
  key: "product",
  storage,
  keyPrefix: "redux-",
  whitelist: ["checkout"],
};

const companyPersistConfig = {
  key: "company",
  storage,
  keyPrefix: "redux-",
  whitelist: ["selectedCompany", "companies"],
};

export const rootReducer = combineReducers({
  calendar: calendarReducer,
  user: userReducer,
  role: roleReducer,
  access: accessReducer,
  product: persistReducer(productPersistConfig, productReducer),
  chat: chatReducer,
  kanban: kanbanReducer,
  company: persistReducer(companyPersistConfig, companyReducer),
});
